import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  leading?: ReactNode;
  footer?: ReactNode;
  footerClassName?: string;
}

export function SectionHeader({
  icon,
  title,
  subtitle,
  leading,
  footer,
  footerClassName,
}: SectionHeaderProps) {
  return (
    <div className="px-4 pt-4 pb-0 ">
      <div className="flex items-center gap-3.5 mb-4 h-10">
        {leading}
        <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10">
          {icon}
        </div>
        <div className='flex flex-col justify-between h-full'>
          <h1 className="text-base font-semibold leading-tight">{title}</h1>
          {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      {footer && (
        <div className={cn('border-b pb-3', footerClassName)}>
          {footer}
        </div>
      )}
    </div>
  );
}
